import request from '@/utils/request';
import ENVIRONMENT from '@/utils/environment';
import { getToken } from '@/utils/auth';

/**
 * 获取白名单数据
 * @method editApplicationUpgrade
 * @param {Object} form 请求参数
 * @return { request } axsio请求封装
 */
export function getWhitesList(params) {
  return request({
    url: `/op/cunwappwhites/type/${params.type}/page`,
    method: 'get',
    params: params
  });
}

/**
 * 添加单个白名单
 * @method editApplicationUpgrade
 * @param {Object} form 请求参数
 * @return { request } axsio请求封装
 */
export function whitesAdd(params) {
  return request({
    url: `/op/cunwappwhites/type/${params.type}`,
    method: 'post',
    params: params
  });
}

/**
 * 删除白名单
 * @method editApplicationUpgrade
 * @param {Object} form 请求参数
 * @return { request } axsio请求封装
 */
export function whitesDelete(params) {
  return request({
    url: `/op/cunwappwhites/type/${params.type}`,
    method: 'delete',
    params: params
  });
}

// 获取资源模板
export function getAppWhitesResourceDefautExport() {
  return `${ENVIRONMENT.BASE_API}/op/cunwappwhites/export?token=${getToken()}`;
}

// 获取资源导入
export function getAppWhitesResourceDefautImport(params) {
  return `${ENVIRONMENT.BASE_API}/op/cunwappwhites/type/${params.type}/import`;
}
